import styled from "styled-components";
import FlexBox from "../../../FlexBox/FlexBox";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _EngagementItemRoot = styled(FlexBox)<{}>(() => {
  return {
    maxWidth: 260,
    ".engagement-product": {
      "&.text-on-desktop": {
        display: "none",
        [`@media ${responsiveMap.mobile}`]: {
          display: "block",
        },
      },
    },
    ".engagement-product-action-button": {
      marginTop: 24 - 8,
      [`@media ${responsiveMap.mobile}`]: {
        width: "100%",
      },
      "&.text-on-desktop": {
        [`@media ${responsiveMap.mobile}`]: {
          width: "unset",
        },
      },
    },
  };
});
